import { Injectable } from '@angular/core';

import { BreadcrumbViewModel } from '../../models/view/breadcrumb';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {

    public breadcrumbList: BreadcrumbViewModel[];

    constructor() {
        this.breadcrumbList = Array<BreadcrumbViewModel>();
    }

    public get() {
        return this.breadcrumbList;
    }

    /**
     * Appends new link to array
     * @param breadcrumbViewModel
     */
    public push(breadcrumbViewModel: BreadcrumbViewModel) {
        for (let index = 0; index < this.breadcrumbList.length; index++) {
            this.breadcrumbList[index].is_active = false;
        }
        breadcrumbViewModel.is_active = true;
        this.breadcrumbList.push(breadcrumbViewModel);
    }

    /**
      * Removes the last link from array
     */
    public pop() {
        this.breadcrumbList.pop();
        for (let index = 0; index < this.breadcrumbList.length; index++) {
            this.breadcrumbList[index].is_active = false;
        }
    }

}

export { BreadcrumbViewModel };
